
import Vue from 'vue'
import { VCard, VCardTitle, VParallax, VRow } from 'vuetify/lib'
import JcdcTitleBar from '@/components/jcdc/JcdcTitleBar.vue'

export default Vue.extend({
  name: 'JcdcLoginTemplate',
  components: { JcdcTitleBar, VCard, VCardTitle, VParallax, VRow },
  props: {
    appTitle: { type: String, required: true },
    appSubtitle: { type: String, required: true },
    maxWidth: { type: String, default: '400px' },
  },
  computed: {
    bgHeight() {
      const { body } = document,
        html = document.documentElement,
        height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        )
      return height
    },
  },
})
